import React from 'react';
import PropTypes from 'prop-types';

import GooglePublisherTag from '../containers/GooglePublisherTag';
import {bottomMPUProps, topMPUProps} from '../components/GptProperties';
import AdvertWrapper from '../components/AdvertWrapper';
import MostReadAll from '../containers/MostReadAll';
import RacingTips from '../containers/RacingTips';
import HorseRacingNextRaceOff from '../containers/HorseRacingNextRaceOff';
import FootballTips from '../containers/FootballTips';
import MostReadFootball from "../containers/MostReadFootball";
import MostReadRacing from "../containers/MostReadRacing";
import HorseRacingMostFollowed from "../../HorseRacing/containers/HorseRacingMostFollowed";
import FootballLiveHomeVidiprinterContainer from "../../Football/containers/FootballLiveHomeVidiprinterContainer";
import InsiderMpu from '../../../modules/Common/containers/InsiderMpu';

export function RightColumn(props) {
  const { sport, location, content } = props;

  const blocks = {
    mostReadAll: {
      id: "right-most-read",
      component: <MostReadAll location={location}/>
    },
    mostReadRacing: {
      id: "right-most-read-racing",
      component: <MostReadRacing location={location} />
    },
    mostReadFootball: {
      id: "right-most-read-football",
      component: <MostReadFootball location={location} />
    },
    topMpu: {
      id: "right-first-mpu",
      component: <GooglePublisherTag adUnitPath={topMPUProps.adUnitPath} type={topMPUProps.type} />
    },
    horseRacingNextRaceOff: {
      id: "right-next-race",
      component: <HorseRacingNextRaceOff location={location} plainTitle  />
    },
    horseRacingNextRaceOffAll: {
      id: "right-next-race-all",
      component: <HorseRacingNextRaceOff location={location} plainTitle displayAll />
    },
    racingTips: {
      id: "right-racing-tips",
      component: <RacingTips location={location} plainTitle />
    },
    ocWidget: {
      id: "right-oc",
      component: <AdvertWrapper ocSlot={[sport, 'mpu']} additionalProperties={{view: sport}} />
    },
    horseRacingMostFollowed: {
      id: "right-horse-racing-most-followed",
      component: <HorseRacingMostFollowed location={location} plainTitle />
    },
    footballTips: {
      id: "right-football-tips",
      component: <FootballTips location={location} plainTitle />
    },
    bottomMpu: {
      id: "right-bottom-mpu",
      component: <GooglePublisherTag adUnitPath={bottomMPUProps.adUnitPath} type={bottomMPUProps.type} />
    },
    vidiPrinter: {
      id: "right-vidiprinter",
      component: <FootballLiveHomeVidiprinterContainer location={location} />
    },
    insiderMpu: {
      id: "right-insider-mpu",
      component: <InsiderMpu />
    }
  };

  return (
    <div className="main-layout-right-column">
      { content.map((blockName, index) => {
        const {id, component} = blocks[blockName];
        const isLastItem = index === content.length - 1;
        const className = isLastItem ? "main-layout-block last-desktop" : "main-layout-block";

        return <div key={id} id={id} className={className}>
          {component}
        </div>
      }) }
    </div>
  );
}

RightColumn.propTypes = {
  location: PropTypes.object.isRequired,
  sport: PropTypes.string.isRequired,
  content: PropTypes.array,
};

RightColumn.defaultProps = {
  content: ["mostReadAll", "topMpu", "racingTips", "horseRacingNextRaceOff", "footballTips", "bottomMpu", "ocWidget"],
};



// WEBPACK FOOTER //
// ./modules/Common/pages/RightColumn.js